// extracted by mini-css-extract-plugin
export var circle = "_ay-1";
export var exitConfirmationModal = "_ay-5";
export var iframe = "_ay-0";
export var offline = "_ay-3";
export var online = "_ay-2";
export var workstationSelectError = "_ay-4";